import React, { useContext } from 'react';
import { PatientInfoFormContext } from './PatientInfoFormProvider';
import PatientInfoFormView from './PatientInfoFormView';

const PatientInfoFormContainer = (props) => {
    const formContext = useContext(PatientInfoFormContext);
    return <PatientInfoFormView {...props} {...formContext} />;
};

export default PatientInfoFormContainer;
